import { useIncrementalQuery, useApiErrorMessageToast } from '~/pages/_shared';
import {
   GetTeamCourseAssignmentsOptions,
   GetTeamCourseAssignmentsErrorCode,
   getTeamCourseAssignmentsFromClient,
} from '~/pages/api/courses/assignments/team/getTeamCourseAssignments.api';
import { useLocalization } from '~/framework';

const KEY = 'team-course-assignments';

export function getTeamCourseAssignmentsKey() {
   return [KEY];
}

export function useTeamCourseAssignments(
   teamid: number,
   options?: GetTeamCourseAssignmentsOptions
) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } =
      useApiErrorMessageToast<GetTeamCourseAssignmentsErrorCode>({
         'teams.team_not_found': _js('Could not find selected team'),
         default: _js(
            'There was a problem retrieving your skilled teams in a course. Please try again.'
         ),
      });
   return useIncrementalQuery(
      [KEY, teamid, options],
      async page => {
         let { course_assignments: data, hasMore } = await getTeamCourseAssignmentsFromClient(
            teamid,
            {
               ...options,
               page,
            }
         );
         return { page, data, hasMore };
      },
      { firstPage: 1, onError: handleErrorOrRedirectToLogin }
   );
}
